// extracted by mini-css-extract-plugin
export var discard = "_2l-3";
export var muiTooltipTooltip = "_2l-5";
export var notificationBar = "_2l-2";
export var saveButtonHoverSlotWrapper = "_2l-4";
export var show = "_2l-1";
export var spacer = "_2l-0";